import { render, staticRenderFns } from "./AttachmentsDialogTrigger.vue?vue&type=template&id=8a28e266&"
import script from "./AttachmentsDialogTrigger.vue?vue&type=script&lang=js&"
export * from "./AttachmentsDialogTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports